import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["editor", "input", "source", "sourceButton"]

  connect() {
    this.editorTarget.innerHTML = this.inputTarget.value
    this.boundSync = () => this.sync()
    this.element.closest("form")?.addEventListener("submit", this.boundSync)
  }

  disconnect() {
    this.element.closest("form")?.removeEventListener("submit", this.boundSync)
  }

  format({ params: { command, value } }) {
    this.editorTarget.focus()
    document.execCommand(command, false, value || null)
    this.sync()
  }

  addLink() {
    const url = window.prompt(this.element.dataset.htmlEditorLinkPrompt)
    if (!url) return

    const normalizedUrl = this.normalizedUrl(url)
    if (!normalizedUrl) return

    this.editorTarget.focus()
    document.execCommand("createLink", false, normalizedUrl)
    this.sync()
  }

  toggleSource() {
    if (this.sourceTarget.hidden) {
      this.sourceTarget.value = this.editorTarget.innerHTML
      this.editorTarget.hidden = true
      this.sourceTarget.hidden = false
      this.sourceButtonTarget.classList.add("active")
      this.sourceTarget.focus()
    } else {
      this.editorTarget.innerHTML = this.sourceTarget.value
      this.sourceTarget.hidden = true
      this.editorTarget.hidden = false
      this.sourceButtonTarget.classList.remove("active")
      this.editorTarget.focus()
      this.sync()
    }
  }

  sync() {
    const html = this.sourceTarget.hidden ? this.editorTarget.innerHTML : this.sourceTarget.value
    this.inputTarget.value = html
  }

  normalizedUrl(url) {
    const candidate = url.trim()
    if (/^(https?:|mailto:|tel:)/i.test(candidate)) return candidate
    if (/^[/#]/.test(candidate)) return candidate
    return `https://${candidate}`
  }
}
